import script from "./CarList.vue?vue&type=script&setup=true&lang=js"
export * from "./CarList.vue?vue&type=script&setup=true&lang=js"

import "./CarList.vue?vue&type=style&index=0&id=31d65a13&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d65a13"]])

export default __exports__